import { getSettings } from './getSettings';

export const Filters = {
  STATE_FILTER: 'STATE_FILTER',
  METRO_FILTER: 'METRO_FILTER',
  PRICE_RANGE: 'PRICE_RANGE',
  BEDS_BATHS: 'BEDS_BATHS',
  HOME_TYPES: 'HOME_TYPES',
  BRANDS: 'BRANDS',
  MORE: 'MORE',
  MOBILE: 'MOBILE',
  RESET: 'RESET',
  NUMBER_FLOORS: 'NUMBER_OF_FLOORS',
  CITY_FILTER: 'CITY_FILTER'
};

export const Brands = {
  CENTURY_COMMUNITIES: 'Century Communities',
  CENTURY_COMPLETE: 'Century Complete'
};


const settings = getSettings(['century', 'settings']);

export const Markers = {
  PURPLE_PIN: settings.purplePin,
  PURPLE_PIN_ACTIVE: settings.purplePinActive,
  BLUE_PIN: settings.bluePin,
  BLUE_PIN_ACTIVE: settings.bluePinActive,
  PURPLE_CLUSTER: settings.purpleClusterMarker,
  BLUE_CLUSTER: settings.blueClusterMarker,
  PURPLE_PIN_SOLID: settings.purplePinSolid,
  PURPLE_PIN_SOLID_ACTIVE: settings.purplePinSolidActive,
  BLUE_PIN_SOLID: settings.bluePinSolid,
  BLUE_PIN_SOLID_ACTIVE: settings.bluePinSolidActive
};
